import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DeviceRegistrationRequest, UserDeviceEntity } from '../models/user-device.model';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    private http = inject(HttpClient);
    private apiUrl = `${environment.aiServiceApiUrl}devices`;

    registerDevice(request: DeviceRegistrationRequest): Observable<UserDeviceEntity> {
        return this.http.post<UserDeviceEntity>(this.apiUrl, request);
    }

    getMyDevices(): Observable<UserDeviceEntity[]> {
        return this.http.get<UserDeviceEntity[]>(this.apiUrl);
    }

    unregisterDevice(fcmToken: string): Observable<void> {
        return this.http.delete<void>(this.apiUrl, { params: { fcmToken } });
    }
}
